import React from 'react'
import { StyledButton, StyledButtonChildrenContainer } from './styled'

export const Button = ({
  label,
  iconLeft,
  iconRight,
  size = 'large',
  $variant = 'primary',
  disabled = false,
  alignSelf,
  type,
  onClick,
  backgroundColor,
  hoverColor,
  disabledColor,
  focusColor,
  $underline,
  $showBorder,
  style,
  ...props
}) => {
  return (
    <StyledButton
      label="button"
      size={size}
      $variant={$variant}
      disabled={disabled}
      alignSelf={alignSelf}
      type={type}
      onClick={onClick}
      backgroundColor={backgroundColor}
      hoverColor={hoverColor}
      disabledColor={disabledColor}
      focusColor={focusColor}
      $underline={$underline}
      $showBorder={$showBorder}
      style={style}
      {...props}
    >
        {iconLeft}
        {label}
        {iconRight}
    </StyledButton>
  )
}